import { queryOptions } from "@tanstack/react-query";
import { loadProgramDetail } from "../one-pager-data";
import type { ProgramDetailInput } from "../types";

export function programDetailOptions(input: ProgramDetailInput) {
  return queryOptions({
    queryKey: ["play", "program-detail", input],
    staleTime: 60_000,
    retry: false,
    queryFn: ({ signal }) => loadProgramDetail({ input, signal }),
  });
}
